import {
  AfterContentInit,
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ContentChildren,
  Input,
  OnChanges,
  QueryList,
  SimpleChanges,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { SortState, TableColumn } from '@app/shared/models/common.model';
import { TableColumnDirective } from './table-column.directive';

interface ColumnDefinition {
  key: string;
  config: TableColumn;
}

// Handles table rendering and sorting; consumers own filtering and export.
@Component({
  selector: 'app-sortable-table',
  templateUrl: './sortable-table.component.html',
  styleUrl: './sortable-table.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SortableTableComponent implements OnChanges, AfterContentInit, AfterViewInit {
  @Input() columns!: Map<string, TableColumn>;
  @Input() data: any[] = [];
  @Input() footer?: Record<string, any> | null;
  @Input() initialSort?: SortState;
  @Input() maxHeight = 460;
  @Input() emptyMessage = '';

  @ViewChild(MatSort) private matSort!: MatSort;
  @ContentChildren(TableColumnDirective) private cellDefs!: QueryList<TableColumnDirective>;

  readonly dataSource = new MatTableDataSource<any>([]);
  cellTemplates = new Map<string, TemplateRef<unknown>>();
  columnDefinitions: ColumnDefinition[] = [];
  columnKeys: string[] = [];

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['columns']) {
      this.columnDefinitions = Array.from(this.columns?.entries() ?? [])
        .map(([key, config]) => ({ key, config }));
      this.columnKeys = this.columnDefinitions.map((column) => column.key);
    }
    if (changes['data']) {
      this.dataSource.data = this.data ?? [];
    }
  }

  ngAfterContentInit(): void {
    this.cellTemplates = new Map(this.cellDefs.map((d) => [d.columnKey, d.template]));
  }

  ngAfterViewInit(): void {
    this.dataSource.sort = this.matSort;
  }

  trackRow = (_index: number, row: any): unknown =>
    row?.id ?? row?.locationId ?? row;
}
